import React from 'react';
import { string, func, bool } from 'prop-types';

import { Button } from '@thd-olt-component-react/button';

import { noop } from '../../../../utils/promo-utils';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { PromoQuantity } from '../../../promo-quantity/PromoQuantity';
import { PromoSelectCta } from '../../../promo-select-cta/PromoSelectCta';
import { PromoAddToCart } from '../../../promo-add-to-cart/PromoAddToCart';
import { PromoCheckboxCta } from '../../../promo-checkbox-cta/PromoCheckboxCta';
import './PromoSidecarCta.scss';

export const PromoSidecarCta = ({
  itemId, onSelect, selected, setQuantityWarningText, showQuantityWarningState, displayPosition
}) => {
  const { promoCartItemsObj } = usePromoCart();
  const {
    isBogo, isMsb, isBmsm, products, singleItemIdToDisplay
  } = usePromoModel();

  const product = products.get(itemId);
  const url = product?.identifiers?.canonicalUrl || '';
  const promoItemModel = promoCartItemsObj[itemId];
  const productInCartQuantity = promoItemModel?.quantity || 0;

  return (
    <div className="promo-quickview-cta-button-container">
      {(isBogo && !singleItemIdToDisplay) && (
        <PromoSelectCta
          onSelect={onSelect}
          selected={selected}
          dark={false}
          className="promo-quickview-cta-button promo-quickview-cta-button--free"
        />
      )}
      {(isBogo && singleItemIdToDisplay) && (
        <PromoCheckboxCta
          onSelect={onSelect}
          selected={selected}
          isInDrawer
        />
      )}
      {(isMsb || isBmsm) && (
        <div className="promo-quickview-cta-button">
          {productInCartQuantity > 0 ? (
            <PromoQuantity
              itemId={itemId}
              setWarningText={setQuantityWarningText}
              showWarningState={showQuantityWarningState}
            />
          ) : (
            <PromoAddToCart itemId={itemId} displayPosition={displayPosition} />
          )}
        </div>
      )}
      <Button
        className="promo-quickview-cta-button"
        outline
        dark
        tag="a"
        href={url}
        target="_self"
      >
        See Full Details
      </Button>
    </div>
  );
};

PromoSidecarCta.displayName = 'PromoSidecarCta';

PromoSidecarCta.propTypes = {
  itemId: string.isRequired,
  onSelect: func,
  selected: bool,
  setQuantityWarningText: func,
  showQuantityWarningState: bool,
  displayPosition: string.isRequired
};

PromoSidecarCta.defaultProps = {
  onSelect: noop,
  selected: false,
  setQuantityWarningText: noop,
  showQuantityWarningState: false
};
